var dateForm = function(holderID,cmsForm,config={},initialValues=[]){
  this.holderID = holderID;
  this.holder = document.getElementById(holderID);
  this.holder.classList.add("dateForm");
  this.cmsForm = cmsForm;
  this.config = config;
  this.initialValues = initialValues;
  this.dateCount = 0;
  this.dateDiv = [];
  this.recurringSelect = [];

  this.loadInitialValues();

  this.events();
};

dateForm.prototype.update = function(initialValues){
  this.initialValues = initialValues;
  this.dateCount = 0;
  this.holder.innerHTML = "";
  this.loadInitialValues();
}


dateForm.prototype.events = function(){
  var addDateLinks = document.querySelectorAll(".dateForm_addDate");
  for(let i = 0;i<addDateLinks.length;i++){
    let d = addDateLinks[i];
    d.addEventListener("click",(e)=>{
      e.preventDefault();
      this.addDate();
    });
  }


};

dateForm.prototype.loadInitialValues = function(){
  let i = 0;
  let numFields = this.initialValues.length == 0 ? 1 : this.initialValues.length;

  while(i < numFields){
    this.addDate();
    i++;
  }
};

dateForm.prototype.recurringField = function(options={}){
  this.recurringSelect[this.dateCount] = document.createElement("select");
  this.recurringSelect[this.dateCount].classList.add("recurringSelect");

  if(options.disabled){
    this.recurringSelect[this.dateCount].classList.add("disabled");
    this.recurringSelect[this.dateCount].setAttribute("disabled","disabled");

  }

  //this.dateDiv[this.dateCount].append(this.recurringSelect[this.dateCount]);
  var recurringSelectHolder = document.createElement("div");
  recurringSelectHolder.classList.add("recurringDateField");
  var rsLabel = document.createElement("label");
  rsLabel.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Repeat</title><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M320 120l48 48-48 48"/><path d="M352 168H144a80.24 80.24 0 00-80 80v16M192 392l-48-48 48-48" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"/><path d="M160 344h208a80.24 80.24 0 0080-80v-16" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"/></svg>';
  recurringSelectHolder.append(rsLabel);
  rsLabel.append(this.recurringSelect[this.dateCount]);
  this.dateDiv[this.dateCount].insertBefore(recurringSelectHolder,this.dateDiv[this.dateCount].querySelector(".timeField"));
  //this.dateDiv[this.dateCount].insertBefore(this.recurringSelect[this.dateCount],this.dateDiv[this.dateCount].querySelector(".timeField"));
  this.recurringFieldOptions();
  //this.recurringFieldEvents();
};

dateForm.prototype.recurringUpdate = function(index){
  this.recurringFieldOptions(index);
};

dateForm.prototype.recurringFieldOptions = function(index=false){
  if(index === false){
    index = this.dateCount;
  }

  if(!this.recurringSelect[index]) return;

  var selectedDateInput = this.dateDiv[index];

  if(!selectedDateInput) return;

  var dateValue = selectedDateInput.querySelector("input").value;
  if(!dateValue || dateValue == ""){
    this.recurringSelect[index].style.display = "none";
    return;
  }
  var [valueMonth,valueDate,valueYear] = dateValue.split("-");
  var dateObj = new Date(Date.UTC(parseInt(valueYear),parseInt(valueMonth)-1,parseInt(valueDate)));
  var timestamp = dateObj.getTime();
  this.recurringSelect[index].style.display = "block";

  var weekdays = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];

  var weekday = weekdays[dateObj.getUTCDay()];
  var weekNum = Math.ceil(dateObj.getUTCDate()/7);
  var utcWeekNum = Math.ceil(dateObj.getUTCDate()/7);
  var weekString = weekNum + "st";
  if(weekNum == 2){
    weekString = "2nd";
  } else if(weekNum == 3){
    weekString = "3rd";
  } else if(weekNum == 4){
    weekString = "4th";
  } else if(weekNum == 5){
    weekString = "5th";
  }

  var additionalOptions = {};



  var options = {
    "1":"Recurring Event Options:",
    "2":"This Event Does Not Repeat",
    ['{"repeat_day":"'+dateObj.getUTCDay()+'"}']:"Repeat Every "+weekday,
    ['{"repeat_day_week":"'+dateObj.getUTCDay()+':'+weekNum+'"}']:"Repeat Every "+weekString+" "+weekday+ " of the Month",
    ['{"repeat_date":"'+dateObj.getUTCDate()+'"}']:"Repeat Every "+moment.utc(timestamp).format("Do") +" of the Month",
    ...additionalOptions
  };

  this.recurringSelect[index].innerHTML = "";

  Object.keys(options).forEach(value=>{
    var newOption = document.createElement("option");
    newOption.setAttribute("value",value);
    newOption.innerText = options[value];
    this.recurringSelect[index].append(newOption);

    if(this.initialValues && this.initialValues[index]){
      Object.keys(this.initialValues[index]).forEach(key=>{
        if(this.initialValues[index][key] !== null){
          var keyString = JSON.stringify({[key]:this.initialValues[index][key].toString()});
          if(value == keyString){
            newOption.setAttribute("selected","selected");
          }

        }
      })
    }

  });


};

dateForm.prototype.addDate = function(){

  var prevStart = "";
  var prevEnd = "";
  if(this.dateCount > 0){
    var prevStartInput = document.querySelectorAll("div[data-date-key='starttime']");
    prevStartInput = prevStartInput[prevStartInput.length - 1];
    if(prevStartInput){
      prevStart = prevStartInput.getAttribute("data-value");
    }

    var prevEndInput = document.querySelectorAll("div[data-date-key='endtime']");
    prevEndInput = prevEndInput[prevEndInput.length - 1];
    if(prevEndInput){
      prevEnd = prevEndInput.getAttribute("data-value");
    }
  }

  var disableTag = "";
  if(this.config.disableDates){
    disableTag = ' data-disable="true"';
  } 
  var dateHTML = '<div '+disableTag+' data-required="true" data-onChange="dates.recurringUpdate('+this.dateCount+')" data-value="'+(this.initialValues[this.dateCount] ? this.initialValues[this.dateCount].date  : "")+'" data-label="Date of Event" class="dateField" data-future="true" data-date-key="startdate" data-name="startdate'+this.dateCount+'" data-format="dddd, MMMM DD, YYYY" data-placeholder="Choose a Date"></div>';
  dateHTML += '<div data-required="true" data-value="'+(this.initialValues[this.dateCount] ? this.initialValues[this.dateCount].startTime  : prevStart)+'" data-label="Start Time" class="timeField" data-future="true" data-date-key="starttime" data-name="starttime'+this.dateCount+'" data-placeholder="Choose a Time"></div>';
  dateHTML += '<div data-required="true" data-value="'+(this.initialValues[this.dateCount] ? this.initialValues[this.dateCount].endTime  : prevEnd)+'" data-label="End Time" class="timeField" data-future="true" data-date-key="endtime" data-name="endtime'+this.dateCount+'" data-placeholder="Choose a Time"></div>';


  this.dateDiv[this.dateCount] = document.createElement("div");
  this.dateDiv[this.dateCount].classList.add("date");
  this.dateDiv[this.dateCount].innerHTML = dateHTML;


  if(this.dateCount > 0){
    if(!this.config.disableDates){
      var closeButton = document.createElement("div");
      closeButton.classList.add("removeDate");
      closeButton.setAttribute("data-index",this.dateCount);
      closeButton.innerHTML = "<span>&times;</span> REMOVE";
      this.dateDiv[this.dateCount].append(closeButton);
      closeButton.addEventListener("click",(e)=>{
        e.preventDefault();
        this.dateDiv[e.currentTarget.getAttribute("data-index")].remove();
      });
    }
  }


  this.holder.append(this.dateDiv[this.dateCount]);
  this.cmsForm.dateFields();
  this.cmsForm.timeFields();
  this.recurringField({disabled:this.config.disableDates});
  this.dateCount++;
};



dateForm.prototype.getValues = function(){
  var dates = this.holder.querySelectorAll(".date");
  var dateArray = [];
  for(let i = 0;i<dates.length;i++){
    var dateHolder = dates[i];
    var startDate = dateHolder.querySelector("div[data-date-key='startdate']");
    var startTime = dateHolder.querySelector("div[data-date-key='starttime']");
    var endTime = dateHolder.querySelector("div[data-date-key='endtime']");

    var startDateValue = startDate.getAttribute("data-value");
    var [valueMonth,valueDate,valueYear] = startDateValue.split("-");
    var dateObj = new Date(Date.UTC(valueYear,parseInt(valueMonth)-1,valueDate));
    var timestamp = dateObj.getTime();

    var recurringValues = {};
    var recurringField = dateHolder.querySelector(".recurringSelect");
    if(recurringField && recurringField.value !== "1" && recurringField.value !== "2" && recurringField.value !== ""){
      recurringValues  = JSON.parse(recurringField.value);
    }

    dateArray.push({
      timestamp:timestamp,
      date:startDateValue,
      startTime:startTime.getAttribute("data-value"),
      endTime:endTime.getAttribute("data-value"),
      ...recurringValues
    }); 


  }
  return dateArray;
}
